import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled, { css } from 'styled-components';
import { Element } from 'react-scroll';
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';
import Slider from "react-slick";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Header from '../components/Header';
import Footer from '../components/Footer';
import VideoPlayer from '../components/VideoPlayer';
// import Button from '../components/Button';
import Popup1 from '../popup/Popup1';
import Popup2 from '../popup/Popup2';
import Popup3 from '../popup/Popup3';
import Popup4 from '../popup/Popup4';
import Popup5 from '../popup/Popup5';
import Popup6 from '../popup/Popup6';
import Accordion from '../components/Accordion';
import Wave from '../components/Wave';
import Close from '../components/icons/Close';
import NextArrow from '../components/icons/NextArrow';
import PrevArrow from '../components/icons/PrevArrow';
import { timestemp, mode, dataLayer } from '../App';
import { PopupBottomDecoWrapper, PopupBottomDeco } from '../popup/styles';

const HifiInfoArr = [
  { line1: '24 bit 錄音室', line2: '原音重現' },
  { line1: 'FLAC', line2: '無損格式' },
  { line1: '錄音室', line2: '原音母帶版本' }, 
  { line1: '升頻版本', line2: '極緻再提升' },
  { line1: '最大 24 bit', line2: 'FLAC 歌庫' },
  { line1: '音源資訊', line2: '格式數據盡現' }
];

const PopupArr = [
  <Popup1 />,
  <Popup2 />,
  <Popup3 />,
  <Popup4 />,
  <Popup5 />,
  <Popup6 />
]

export const StyledNextArrow = styled(NextArrow)`
  right: -36px;
  margin-top: auto !important;

  &:before {
    content: '';
  }
  svg {
    width: 26px;
    fill: ${props => props.theme.colors.primary};
  }
`;

export const StyledPrevArrow = styled(PrevArrow)`
  left: -60px;
  margin-top: auto !important;
  
  &:before {
    content: '';
  }
  svg {
    width: 26px;
    fill: ${props => props.theme.colors.primary};
  }
`;

export const Section = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => !!props.bg && !props.bgFixed && css`
    background-image: url(${props.bg});
    background-size: cover;
    background-position: center;
  `};


  ${props => !!props.bgd && css`
    @media only screen and (min-width: 768px) {
      background-image: url(${props.bgd});
      background-size: cover;
      background-position: center;
    }
  `}
  
  ${props => !!props.bgFixed && css`
    background-attachment: fixed;
  `};

  ${props => !!props.bgColor && css`
    @media only screen and (min-width: 768px) {
      background-size: 50%;
      background-repeat: no-repeat;
      background-position: right top;
      background-color: #181818;
    }
  `}

  ${props => !!props.autoHeight && css`
    height: auto;
  `}

  ${props => !!props.bgFixed && css`
    @media only screen and (max-width: 700px) {
      &:before {
        position: fixed;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        content: ' ';
        display: block;
        background-image: url(${props.bg});
        background-size: cover;
        background-position: center;
      }
    }
  `}

  .goldline {
    position: relative;
    top: -56px;
  }
`;

export const Heading = styled.h2`
  color: ${props => props.theme.colors.primary};
  width: 100%;
  text-align: center;
  font-size: ${props => props.theme.font.size};
  font-weight: bold;
  padding-top: 40px;
  padding-bottom: 8px;

  @media only screen and (min-width: 768px) {
    font-size: 40px;
  }
`;

export const LineHeading = styled.h2`
  position: relative;
  font-size: ${props => props.theme.font.size};
  z-index: 1;
  overflow: hidden;
  text-align: center;
  color: ${props => props.theme.colors.primary};
  width: calc(100% - 64px);
  margin: auto;
  display: flex;
  align-items: center;
  white-space: nowrap;

  span {
    display: block;
    padding: 0 16px;
  }

  &:before, &:after {
      width: 50%;
      height: 1.5px;
      content: ' ';
      background-color: ${props => props.theme.colors.primary};
  }

  @media only screen and (min-width: 768px) {
    font-size: 48px;
    &:before, &:after {
      height: 5px;
    }
  }
`;

const Text = styled.div`
  color: ${props => props.theme.colors.text};
  text-align: center;
  line-height: 1.5;
`;

const TopSlogan = styled.div`
  @media only screen and (min-width: 768px) {
    margin-top: -40px;
  }
`;

const SloganHeading = styled(Heading)`
  padding-bottom: 0;
  font-size: 21px;
`;

const Slogan = styled.div`
  font-weight: bold;
  text-align: center;
  color: white;

  sup {
    position: absolute;
    top: 0;
    font-size: 16px;
  }

  .eng {
    font-size: 52px;
  }

  .chi {
    position: relative;
    font-size: 36px;
  }

  @media only screen and (min-width: 768px) {
    font-size: 100px;
    line-height: .5;

    .eng {
      display: inline-block;
      font-size: 70px;
    }

    .chi {
      display: inline-block;
      font-size: 62px;
    }
  }
`;

const SubSlogan = styled.div`
  color: ${props => props.theme.colors.primary};
  line-height: 1.5;
  padding-top: 32px;
  font-size: 20px;

  @media only screen and (min-width: 768px) {
    font-size: 30px;
    font-weight: normal;
  }
`;

export const StyledVideoPlayer = styled(VideoPlayer)`
  width: calc(100vw - 22px);
  box-sizing: border-box;
  max-width: 1000px;
  margin: auto;
  border: 1px solid ${props => props.theme.colors.border};
`;

const GridWrapper = styled.div`
  display: table;
  width: 100%;
`;

const Grid = styled.div`
  width: 50%;
  display: inline-block;
  padding: 8px;
  box-sizing: border-box;

  ${props => !!props.avatar && css`
    background-image: url(${props.avatar});
    background-position: center;
    background-size: cover;
  `}

  ${props => !!props.noPadding && css`
    padding: 0;
  `}

  @media only screen and (min-width: 769px) {
    width: 33.333%;
    float: none;
    display: inline-block;
    margin: 24px 0;
    vertical-align: top;
  }
`;

const StyledGridWrapper = styled(GridWrapper)`
  width: 80%;
  margin: 30px auto;
`;

const CenterGrid = styled(Grid)`
  text-align: center;
  color: white;

  div {
    text-decoration: underline;
    font-size: 12px;
    cursor: pointer;
  }

  img {
    width: 50%;
    cursor: pointer;
  }

  @media only screen and (min-width: 768px) {
    img {
      width: 33.333%;
    }

    .line {
      font-size: 16px;
    }
  }
`;

const FullWidth = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  padding: 30px 0;
`;

const ScaleBubble1 = styled.img`
  position: absolute;
  left: 20vw;
  bottom: 200px;
	transform: scale(1);
	opacity: 1;
	animation: heart 2.7s linear 2.4s;
	animation-iteration-count: infinite;
  animation-delay: .5s;
`;

const ScaleBubble2 = styled.img`
  position: absolute;
  right: 25vw;
  bottom: 200px;
	transform: scale(1);
	opacity: 1;
	animation: heart 2.7s linear 2.4s;
	animation-iteration-count: infinite;
`;

const ParallaxWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Deco1 = styled.div`
  position: absolute;
  top: 10%;
  right: 10%;
`;

const Deco2 = styled.div`
  position: absolute;
  top: 19%;
  right: 26%;

  @media only screen and (min-width: 768px) {
    top: 15%;
  }
`;

const Deco3 = styled.div`
  position: absolute;
  top: 30%;
  left: 10%;

  @media only screen and (min-width: 768px) {
    left: 22%;
    top: 22%;

    img {
      width: 25vw;
    }
  }
`;

const Deco4 = styled.div`
  position: absolute;
  top: 41%;
  right: 36%;
`;

const Deco5 = styled.div`
  position: absolute;
  top: 35%;
  left: 10%;
`;

// const Deco6 = styled.div`
//   position: absolute;
//   top: 64%;
//   left: 10%;
// `;

const Deco7 = styled.div`
  position: absolute;
  top: 64%;
  right: 27%;
`;

const Deco8 = styled.div`
  position: absolute;
  top: 20%;
  right: 23%;
`;

const Deco9 = styled.div`
  position: absolute;
  top: 80%;
  left: 10%;
`;

const Deco10 = styled.div`
  position: absolute;
  top: 15%;
  right: 5%;
`;

const Deco11 = styled.div`
  position: absolute;
  bottom: 3%;
  left: 23%;
`;

const BadgeWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 70px;
  width: 100%;
  height: 50%;


  @media only screen and (min-width: 768px) {
    bottom: 100px;
  }
`;

const BadgeColumn = styled.div`
  display: inline-block;
  width: 33.333%;
  height: 100%;

  img {
    position: relative;
    animation: pump 1.5s ease-in-out 2.5s;
    animation-delay: ${props => `${props.animationIndex * .5}s`};
    animation-iteration-count: infinite;
  }

  &:first-child {
    img {
      width: 40%;
      margin: auto;
      top: 10%;
      left: -20px;
    }
  }

  &:last-child {
    img {
      width: 50%;
      margin: auto;
      top: 20%;
    }
  }

  &.bubble {
    position: absolute;
  }

  &.bubble1 {
    top: 0;
    left: 65vw;
    img {
      width: 50%;
    }
  }

  &.bubble2 {
    top: calc(100vw - 60%);
    left: calc(50vw - 80px);

    img {
      width: 70%;
    }
  }


  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    img {
      top: 100px;
    }
  }

  @media only screen and (min-width: 736px) {
    width: 20% !important;

    img {
      max-width: 187px;
      top: 150px;
    }

    &:first-child {
      img {
        width: 110px;
        margin: auto;
        top: 45%;
      }
    }

    &:last-child {
      img {
        width: 132px;
        margin: auto;
        top: 20%;
      }
    }

    &.bubble {
      position: relative;
      top: auto;
      left: auto;
      right: auto;
    }

    &.bubble2 {
      top: 10%;
    }
  }
`;

const LandingBannerBox = styled.div`
  text-align: center;
  width: 100%;
`;

const CslBox = styled.div`
  font-size: 12px;
  position: relative;
  /* position: absolute;
  bottom: 25px;
  left: 0; */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.primary};
  padding: 4px 0;
`;

const Tnc = styled.div`
  position: relative;
  color: #888;
  font-size: 8px;
  line-height: 1.5;
  padding: 4px 16px 16px;
`;

const CelebrityGridWrapper = styled.div`
  width: 100%;
  margin: auto;
  padding: 0 8px;
  box-sizing: border-box;
`;

const CelebrityGrid = styled.div`
  position: relative;
  box-sizing: border-box;
  background-image: url(${process.env.REACT_APP_BUILD_URL}/images/site/bubble_artist1.png);
  box-sizing: border-box;
  background-size: contain;
  padding: 8px;

  > div {
    position: relative;
    padding: 4px 0;
  }

  .avatar {
    position: relative;
    overflow: hidden;
    border-radius: 200px;

    &::after {
      position: relative;
      content: ' ';
      display: block;
      padding-top: 100%;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  img.fullwidth {
    width: calc(91% - 24px);
    left: 20px;
  }

  @media only screen and (min-width: 768px) {
    max-width: 75%;
    margin: auto;
  }
`;

const CelebrityGridContent = styled(Grid)`
  /* padding: 0; */
`;

const CelebrityLink = styled.a`
  position: relative;
  display: block;
  color: black;
  text-decoration: none;
`;

const CelebrityGridContentInfo = styled.div`
  position: absolute;
  white-space: nowrap;
  font-size: 10px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  color: white;
  padding: 4px;
  text-align: center;
  width: 100%;
  bottom: 0;
  padding-bottom: 12px;
  background-color: rgba(0,0,0, 0.5);

  b {
    font-size: 15px;
    color: ${props => props.theme.colors.primary};
  }

  ${props => !!props.nobg && css`
    position: absolute !important;
    bottom: 0;
    left: 12px;
    background-color: #572d06;
    color: white;
    width: 100% !important;
    padding: 8px !important;
    max-width: calc(100% - 36px);
  `}

  @media only screen and (min-width: 769px) {
    b{
      font-size: 28px !important;
    }
  }

  @media only screen and (min-width: 768px) {
    width: 100% !important;
    font-size: 16px !important;
    text-align: center;

    b{
      font-size: 20px !important;
    }
  }
`;

export const SliderWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    padding: 24px 0;
    max-width: 80%;
    margin: auto;
  }
`;

export const ModalWrapper = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, .8);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalDim = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const ModalBox = styled.div`
  position: relative;
  width: calc(100% - 8px);
  max-width: 1000px;
  padding: 16px;
  box-sizing: border-box;
`;

export const ModalContent = styled.div`
  position: relative;
  width: 100%;
  padding: 16px 2px;
  box-sizing: border-box;
  background-color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;

export const ModalContentScroll = styled.div`
  position: relative;
  width: 100%;
  /* height: 100vh; */
  max-height: calc(100vh - 240px);
  overflow: auto;
`;

export const StyledClose = styled(Close)`
  position: absolute;
  top: 32px;
  right: 32px;
  cursor: pointer;

  svg {
    width: 24px;
  }
`;

const FaqSection = styled(Section)`
  @media only screen and (min-width: 769px) {
    background-size: 50% !important;
  }
`;

// const ShowAllButton = styled(Button)`
//   margin-top: 125px;
// `;

const getData = async () => {
  let data = [];
  try {
    const response = await axios.get(`${process.env.REACT_APP_BUILD_URL}/data${mode !== 'production' ? '.uat' : ''}.json?t=${timestemp}`);
    if(response.status === 200) {
      data = response.data;
    }

    return data;
  } catch(err) {
    console.log(err);
  }
}

const MusicAppreciation = ({ cslExclusive24bit }) => {
  const [celebritiesData, setCelebritiesData] = useState([]);
  const [genreData, setGenreData] = useState([]);
  const [faqData, setFaqData] = useState([]);
  const [popupIndex, setPopupIndex] = useState(-1);

  useEffect(() => {
    async function fetchData() {
      const data = await getData();
      setCelebritiesData(data.celebrities);
      setGenreData(data.genre);
      setFaqData(data.faq);
    }

    if(celebritiesData.length === 0 || genreData.length === 0) {
      fetchData();
    }
  }, [celebritiesData, genreData]);

  const settings = {
    slidesToShow: Array.isArray(genreData) && genreData.length >= 3 ? 3 : 2,
    className: "center",
    centerMode: Array.isArray(genreData) && genreData.length >= 3,
    nextArrow: <StyledNextArrow />,
    prevArrow: <StyledPrevArrow />,
    infinite: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          className: "center",
          centerMode: true,
          infinite: false,
          centerPadding: "60px",
          slidesToShow: 1,
          speed: 500,
          arrows: false,
        }
      }
    ]
  };

  return (
    <div>
      {celebritiesData.length && genreData.length && <Header />}
      <Element name="banner">
        <Section bg={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg.jpg`} bgd={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg_d.png`} autoHeight>
          <LandingBannerBox>
          <div className="desktop">
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
          {/* <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/moov_dog.png`} alt="" width="80" /> */}
          <TopSlogan>
            <SloganHeading>香港首創</SloganHeading>
            <Slogan><div className="eng">MOOV 24 bit</div> <div className="chi">FLAC無損串流音樂<sup>*</sup></div></Slogan>
            <SubSlogan>錄音室原音重現     最好聽最好<br className="mobile" /></SubSlogan>
          </TopSlogan>
            <div className="mobile">
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
            </div>
            <Wave />
            <img className="goldline mobile" src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldline.png`} alt="" width="100%" />
            <img className="goldline desktop" src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldline_d.png`} alt="" width="100%" />
            <ScaleBubble1 src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/grx1.png`} alt="" width="40" />
            <ScaleBubble2 src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/grx2.png`} alt="" width="40" />
            <BadgeWrapper>
              <BadgeColumn animationIndex={0}>
                <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/badge2.png`} alt="" width="100%" />
              </BadgeColumn>
              <BadgeColumn className="bubble bubble1" animationIndex={1}>
                <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bubble1.png`} alt="" width="100%" />
              </BadgeColumn>
              <BadgeColumn animationIndex={2}>
                <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/badge1.png`} alt="" width="100%" />
              </BadgeColumn>
              <BadgeColumn className="bubble bubble2" animationIndex={3}>
                <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bubble2.png`} alt="" width="100%" />
              </BadgeColumn>
              <BadgeColumn animationIndex={4}>
                <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/badge3.png`} alt="" width="100%" />
              </BadgeColumn>
            </BadgeWrapper>
            {!!cslExclusive24bit && 
            <CslBox>
              於2020年4月至6月優先發售&nbsp;&nbsp;
              <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/csl_logo.png`} alt="" width="162" />
            </CslBox>}
            <Tnc>
            *根據MOOV針對在香港營運之8大音樂串流平台之內部調查。截至2020年4月1日，<br className="mobile" />MOOV是香港首個及唯一音樂串流平台在流動應用程式內提供24 bit FLAC無損音樂，<br className="mobile" />當中包括錄音室原音母帶版本及升頻版本的內容。<br/>
#根據MOOV針對在香港營運之8大音樂串流平台之內部調查。截至2020年 4月1日 ，MOOV擁有香港最大24 bit FLAC 無損串流音樂庫提供 24 bit FLAC 無損音樂庫及音源資訊包括位元度、取樣頻率、<br className="mobile" />音頻格式、版本及位元率之音樂串流平台。
            </Tnc>
          </LandingBannerBox>
        </Section>
      </Element>
      <Element name="hifi">
        <Section bg={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg1.jpg`} autoHeight bgColor="#181617">
          <div>
          <br />
          <Heading>MOOV 24 bit FLAC無損串流音樂</Heading>
          <Text>錄音室原音重現 最好聽最好</Text>
          <br />
          <br />
          {cslExclusive24bit ? 
            <StyledVideoPlayer coverId="home-cover-video" videoUrl={`${process.env.REACT_APP_S3_URL}/experience/Comp+1+moov+zone+mixied_21sec.mp4`} videoPoster={`videoposter1.gif`} /> :
            <StyledVideoPlayer coverId="home-cover-video" videoUrl={`${process.env.REACT_APP_S3_URL}/experience/moov+zone+mixed++71+public.mp4`} videoPoster={`videoposter1.gif`} />
          }
          <br />
          <br />
          <LineHeading><span>原音重現 MOOV 24 bit </span></LineHeading>
          <StyledGridWrapper>
            {HifiInfoArr.map((item, index) => (
              <CenterGrid key={index} onClick={() => {
                  setPopupIndex(index);
                }}>
                <img className={`selling_${index}`} src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/icon${index + 1}.png`} alt="" />
                <br/>
                {/* <br/> */}
                <div className={`line selling_${index}`}>{item.line1}</div>
                <div className={`line selling_${index}`}>{item.line2}</div>
              </CenterGrid> 
            ))}
          </StyledGridWrapper>
          </div>
        </Section>
      </Element>
      <Element name="celebrities">
        <Section bg={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg2.jpg`} bgd={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg2_d.jpg`} autoHeight bgFixed>
          <FullWidth>
            <ParallaxWrapper>
              <ParallaxProvider>
                <Deco1 className="mobile">
                  <Parallax y={[-20, 20]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx1.png` } alt="" width="80" />
                  </Parallax>
                </Deco1>
                <Deco2>
                  <Parallax y={[-20, 20]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx2.png` } alt="" width="80" />
                  </Parallax>
                </Deco2>
                <Deco3>
                  <Parallax y={[0, 40]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx9.png` } alt="" width="80%" />
                  </Parallax>
                </Deco3>
                <Deco4>
                  <Parallax y={[-20, 20]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx3.png` } alt="" width="90" />
                  </Parallax>
                </Deco4>
                <Deco5>
                  <Parallax y={[-20, 20]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx4.png` } alt="" width="40" />
                  </Parallax>
                </Deco5>
                {/* <Deco6>
                  <Parallax y={[-20, 20]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx1.png` } alt="" width="80" />
                  </Parallax>
                </Deco6> */}
                <Deco7 className="desktop">
                  <Parallax y={[-20, 20]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx1.png` } alt="" width="127" />
                  </Parallax>
                </Deco7>
                <Deco8 className="desktop">
                  <Parallax y={[-20, 20]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx6.png` } alt="" width="300" />
                  </Parallax>
                </Deco8>
                <Deco9>
                  <Parallax y={[-20, 20]} tagOuter="div">
                    <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldgrx1.png` } alt="" width="80" />
                  </Parallax>
                </Deco9>
              </ParallaxProvider>
            </ParallaxWrapper>
            <div className="desktop">
              <br />
              <br />
              <br />
            </div>
            <Heading>24 bit 音樂人導賞</Heading>
            <br className="mobile" />
            <CelebrityGridWrapper>
              {Array.isArray(celebritiesData) && celebritiesData.map((item, index) => (
                <CelebrityGridContent key={index} >
                  <CelebrityGrid onClick={() => {
                    dataLayer.push({ event: 'CodeCelebritiesEvent', eventLabel: item.name });
                  }}>
                      <CelebrityLink href={`${process.env.REACT_APP_BASE_URL}?id=${item.id}`}>
                        <div className="avatar">
                          {
                            mode !== 'production' ? 
                              <img src={`${process.env.REACT_APP_BUILD_URL}/uat/celebrities/${item.avatar}`} alt="" width="100%" /> :
                              <img src={`${process.env.REACT_APP_BUILD_URL}/prod/celebrities/${item.avatar}`} alt="" width="100%" />
                          }
                          <CelebrityGridContentInfo>
                            <b>{item.name}</b><br/>{!!item.title && item.title.split('\n').map(function(item, idx) {
                      return (
                          <span key={idx}>
                              {item}
                              <br/>
                          </span>
                      )
                  })}
                          </CelebrityGridContentInfo>
                      </div>
                      </CelebrityLink>
                    </CelebrityGrid>
                </CelebrityGridContent>
            ))}
            </CelebrityGridWrapper>
          </FullWidth>
        </Section>
      </Element>
      <Element name="genres">
        <Section bg={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg3.jpg`}  bgd={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg3_d.jpg`} autoHeight>
          <FullWidth>
            <Heading>24 bit 分類導航</Heading>
            <br />
            <SliderWrapper>
              <Slider {...settings}>
              {Array.isArray(genreData) && genreData.map((item, index) => (
                  <div key={index}  onClick={() => {
                    window.dataLayer.push({ event: 'CodeGenreEvent', eventLabel: item.name });
                  }}>
                    <a href={`${process.env.REACT_APP_BASE_URL}?genre=${item.id}`}>
                      {
                        mode !== 'production' ? 
                          <img src={`${process.env.REACT_APP_BUILD_URL}/uat/genre/${item.cover}`} alt="" width="100%" /> :
                          <img src={`${process.env.REACT_APP_BUILD_URL}/prod/genre/${item.cover}`} alt="" width="100%" />
                      }
                      {/* <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/${item.cover}.jpg`} alt="" width="100%" /> */}
                    </a>
                  </div>
              ))}
              </Slider>
            </SliderWrapper>
          </FullWidth>
        </Section>
      </Element>
      <Element name="faq">
        <FaqSection bg={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg4.jpg`} bgd={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg4.jpg`} autoHeight >
          <FullWidth>
            <>
              <Deco10>
                <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldengrx1.png` } alt="" width="90" />
              </Deco10>
              <Deco11>
                <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/home/goldengrx2.png` } alt="" width="127" />
              </Deco11>
            </>
            <Heading>FAQ</Heading>
            <Accordion faqData={faqData} />
          </FullWidth>
        </FaqSection>
      </Element>
      <Footer cslExclusive24bit={cslExclusive24bit} />
      {popupIndex !== -1 && (
        <ModalWrapper>
          <ModalDim onClick={() => { setPopupIndex(-1); }}/>
          <ModalBox>
            <ModalContent>
              <ModalContentScroll>
                {PopupArr[popupIndex]}
              </ModalContentScroll>
            </ModalContent>
            <StyledClose onClick={() => { setPopupIndex(-1); }} />
            <PopupBottomDecoWrapper>
              <PopupBottomDeco />
            </PopupBottomDecoWrapper>
          </ModalBox>
        </ModalWrapper>
      )}
    </div>
  );
}

export default MusicAppreciation;
